@if (form) {
    <form [formGroup]="form" class="w-100 h-fit-content" fxLayout="column" fxLayoutAlign="start start">
        <mat-accordion class="w-100">
            @for (transactionForm of form.controls?.transactions?.controls; track trackByTransactionIndex(index, transactionForm); let
                index = $index; let first = $first; let last = $last) {
                <af-transaction-expansion-panel
                    [transaction]="transactions && transactions[index]"
                    [transactionForm]="transactionForm"
                    [expanded]="!Spinner.isShown('initForms') && last"
                    [isNew]="false"
                    [showDeleteButton]="showDeleteButton"
                    [showAddTransactionButton]="mode === 'create' && (!Spinner.isShown('createIncident') || !Spinner.isShown('editIncident')) && last"
                    [isAddTransactionButtonDisabled]="form.invalid"
                    [index]="index"
                    [viewIndex]="transactionForm.controls.id.value"
                    (deleteTransactionListener)="deleteTransaction($event, false)"
                    (addNewTransactionListener)="createTransactionForm()"/>
            }
            @for (transactionForm of form.controls?.addedTransactions?.controls; track trackByTransactionIndex(index, transactionForm); let
                index = $index; let first = $first; let last = $last) {
                <af-transaction-expansion-panel
                    [transactionForm]="transactionForm"
                    [customTitle]="isCompromisedPaymentInstrumentType ? 'i18n_af_labelIncidentPaymentInstrument' : null"
                    [expanded]="!Spinner.isShown('initForms') && last"
                    [isNew]="!!transactions?.length"
                    [showDeleteButton]="showDeleteButton"
                    [showAddTransactionButton]="mode === 'create' && (!Spinner.isShown('createIncident') || !Spinner.isShown('editIncident')) && last"
                    [isAddTransactionButtonDisabled]="form.invalid"
                    [index]="index"
                    [viewIndex]="indexStartsFrom + index + 1"
                    (deleteTransactionListener)="deleteTransaction($event, true)"
                    (addNewTransactionListener)="createTransactionForm()"/>
            }
        </mat-accordion>
    </form>
}
